import { Route, Routes, Navigate } from 'react-router-dom'
import { Box, Paper } from '@mui/material'
import PageHeader from 'components/AppBar/PageHeader'
import { BasePathProvider } from 'components/Providers'
import MentorshipTabs, { tabConfig } from './Tabs'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import MyLogs from './MyLogs'
import Mentees from './Mentees'
import Enrollment from './Enrollment'
import Protected from 'components/Protected'
import NotFound from 'components/NotFound'
import { hasPermission } from 'store'

const basePath = '/mentorship'

const isAdmin = () => hasPermission('mentorship.admin')
const isMentorOrAdmin = () => hasPermission('mentorship.mentor') || hasPermission('mentorship.admin')

function ManagementRoutes() {
  return (
    <Paper sx={{ width: '100%', p: 2 }}>
      <MentorshipTabs />
      <Routes>
        <Route path="/">
          <Route index element={<RedirectToFirstPermitted basePath={`${basePath}/management`} items={tabConfig} />} />
          <Route path="mentees/*" element={<Protected allowed={isMentorOrAdmin}><Mentees /></Protected>} />
          <Route path="enrollment/*" element={<Protected allowed={isAdmin}><Enrollment /></Protected>} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Paper>
  )
}

export default function Mentorship() {
  return (
    <BasePathProvider value={`${basePath}/`}>
      <Box sx={{ mb: 2 }}>
        <PageHeader title="Mentorship" />
      </Box>
      <Routes>
        <Route path="my-logs/*" element={
          <Paper sx={{ width: '100%', p: 2 }}>
            <MyLogs />
          </Paper>
        } />
        <Route path="management/*" element={
          <Protected allowed={isMentorOrAdmin}><ManagementRoutes /></Protected>
        } />
        <Route path="*" element={<Navigate to={`${basePath}/my-logs`} replace />} />
      </Routes>
    </BasePathProvider>
  )
}
